module.exports = __webpack_public_path__ + "img/bmlogo.dfb057b3.png";